<app-navbar></app-navbar>
<div
  class="card"
  style="
    padding: 20px; //background-image: url('assets/img/school/bg.png');
    background-color: #005a63;
    background-size: 100px;
    background-attachment: fixed;
  "
>
  <h2 style=" color: white; text-align: center; margin-bottom: 10px">Hearing Section</h2>
  <div>
    <img
      class="img-fluid"
      style="height: 500px; width: 100%; object-fit: fit; border-radius: 10px"
      src="assets/img/school/hearing-section.jpg"
    />
  </div>
  <br />
  <br />
  <div class="container" style="text-align: justify !important">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body text-justify">
            <p>
              Hearing impairment refers to any degree of hearing loss, mild to
              severe, and can occur when there is a problem with a part of the
              ear, including the inner, middle, and outer ears, or the nerves
              needed for hearing. <br />
              <strong>Degree of Hearing loss:</strong> <br />
              Mild hearing loss: Hearing loss of 20 to 40 decibels. Moderate
              hearing loss: Hearing loss of 41 to 60 decibels. Severe hearing
              loss: Hearing loss of 61 to 80 decibels. Profound hearing loss or
              deafness: Hearing loss of more than 81 decibels. <br />
              <strong>Causes of hearing loss and deafness</strong> <br />
              Although these factors can be encountered at different periods
              across the life span, individuals are most susceptible to their
              effects during critical periods in life. <br />
              <strong>Prenatal period</strong> <br />
              • Genetic factors including hereditary and non-hereditary hearing
              loss <br />
              • Intrauterine infections – such as rubella and cytomegalovirus
              infection. Perinatal period <br />
              • Birth asphyxia (a lack of oxygen at the time of birth) <br />
              • Hyperbilirubinemia (severe jaundice in the neonatal period)
              <br />
              • Low-birth weight <br />
              • Other perinatal morbidities and their management. <br />
              <strong>Childhood and adolescence</strong> <br />
              • Chronic ear infections (chronic suppurative otitis media) <br />
              • Collection of fluid in the ear (chronic nonsuppurative otitis
              media) <br />
              • Meningitis and other infections. <br />
              <strong>Adulthood and older age</strong> <br />
              • Chronic diseases <br />
              • Smoking <br />
              • Oosclerosis <br />
              • Age-related sensorineural degeneration <br />
              • Sudden sensorineural hearing loss. <br />
              <strong>Factors across the life span</strong> <br />
              • Cerumen impaction (impacted ear wax) <br />
              • Trauma to the ear or head <br />
              • Loud noise/loud sounds <br />
              • Ototoxic medicines <br />
              • Work related ototoxic chemicals <br />
              • Nutritional deficiencies <br />
              • Viral infections and other ear conditions <br />
              • Delayed onset or progressive genetic hearing loss. <br />
              <strong>The impact of unaddressed hearing loss</strong> <br />
              When unaddressed, hearing loss impacts many aspects of life at
              individual level: <br />
              • Communication and speech <br />
              • Cognition <br />
              • Education and employment: In developing countries, children with
              hearing loss and deafness often do not receive schooling. Adults
              with hearing loss also have a much higher unemployment rate. Among
              those who are employed, a higher percentage of people with hearing
              loss are in the lower grades of employment compared with the
              general workforce. <br />
              • Social isolation, loneliness and stigma <br />
              • Impact on society and economy <br />
              • Effects on years lived with disability (YDLs) and disability
              adjusted life years (DALYs).
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
